import Dexie, { Table } from 'dexie';
import { GetGuiasEnSucursalList, GetMotivoNoEntregaListResponse, GuiaEntregadaRequestDTO, GuiaNoEntregadaRequestDTO, GuiasARepartir } from './generated';

export interface WebAuthnCacheEntry {
    key: string;
    url: string;
    method: string;
    requestBody: string;
    responseBody: unknown;
    status: number;
    updatedAt: number;
}


// 2. Extend Dexie to create your local database
export class AppIndexedDB extends Dexie {
    // Define your tables. The 'OfflineRequest' type matches our interface above.
    guias!: Table<GuiasARepartir, number>;
    motivosNoEntrega!: Table<GetMotivoNoEntregaListResponse, number>;
    guiasEntregadas!: Table<GuiaEntregadaRequestDTO, number>;
    guiasNoEntregadas!: Table<GuiaNoEntregadaRequestDTO, number>;
    webAuthnCache!: Table<WebAuthnCacheEntry, string>;

    constructor() {
        super('LogiFlow360OfflineDB'); // Name of the database



        this.version(1).stores({
            guias: 'guiaId',
            motivosNoEntrega: 'motivoNoEntregaId',
            guiasEntregadas: 'guiaId',
            guiasNoEntregadas: 'guiaId',
            webAuthnCache: '&key,updatedAt',
        });
    }
}

// Export a single instance to use across your application
export const db = new AppIndexedDB();
